import { transformImage } from '@/helpers/transforms'
import type { ImagesCarouselBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import type { ImageGalleryType } from '../blocks/CarouselImageGallery'
import CarouselImageGalleryBlock from '../blocks/CarouselImageGallery'

export const ImageCarouselConverter: JSXConverter<SerializedBlockNode<ImagesCarouselBlock>> = ({
	node,
}) => {
	const { slides } = node.fields

	const slidesData: ImageGalleryType[] = []

	for (const slide of slides || []) {
		const { image, caption } = slide

		const imageData = transformImage(image)

		slidesData.push({
			id: slide.id,
			image: imageData,
			caption: caption,
		})
	}
	return <CarouselImageGalleryBlock images={slidesData} />
}
